import {FlexPage} from '@hconnect/common/components'
import {Stack} from '@mui/material'

type LayoutProps = {
  titleSlot?: React.ReactNode
  aboveTitleSlot?: React.ReactNode
  plantStatusKpisSlot: React.ReactNode
  expertSystemUsageSlot: React.ReactNode
  operationHoursSlot: React.ReactNode
  myTasksSlot: React.ReactNode
  downtimeByCategorySlot: React.ReactNode
  qualityParametersSlot: React.ReactNode
}

export const PlantDashboardDesktopLayout: React.FC<LayoutProps> = ({
  titleSlot,
  aboveTitleSlot,
  plantStatusKpisSlot,
  expertSystemUsageSlot,
  operationHoursSlot,
  myTasksSlot,
  downtimeByCategorySlot,
  qualityParametersSlot
}) => {
  return (
    <FlexPage
      title={titleSlot}
      aboveTitle={aboveTitleSlot}
      nameHeaderSx={{mt: aboveTitleSlot ? 0 : undefined}}
    >
      <Stack direction="row" spacing={2} flexGrow={1} useFlexGap flexWrap="wrap">
        {plantStatusKpisSlot}
        <Stack spacing={2} flex={1} useFlexGap>
          {operationHoursSlot}
          {downtimeByCategorySlot}
        </Stack>
        <Stack spacing={2} flex={1} useFlexGap>
          {qualityParametersSlot}
          <Stack spacing={2} flex={1} useFlexGap flexDirection={'row'}>
            {expertSystemUsageSlot}
            {myTasksSlot}
          </Stack>
        </Stack>
      </Stack>
    </FlexPage>
  )
}
